// src/pages/Metrics/components/FilterMenu.js

import React from "react";
import {
  Menu,
} from "@mui/material";

const FilterMenu = ({
  anchorEl,
  open,
  onClose,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(25,25,25,0.95)",
          backdropFilter: "blur(12px)",
          borderRadius: "18px",
          border: "1px solid rgba(255,255,255,0.08)",
          width: "260px",
          color: "#fff",
          p: 1,
          maxHeight: "85vh",
          overflowY: "auto",
        },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {/* Меню пусто - секции фильтров удалены */}
    </Menu>
  );
};

export default FilterMenu;
